import { propOr } from 'ramda';
import { createSelector } from 'reselect';

import { SORT_FULL_SEATED_BJ_TABLES } from '../../utils/tablesSorting';

export const configSelector = (state) => state.config;

export const configLoadedSelector = createSelector(
  configSelector,
  propOr(false, 'loaded')
);

export const skinColorsSelector = createSelector(
  configSelector,
  propOr({}, 'skin_colors'),
);

export const lobbyConfigSelector = createSelector(
  configSelector,
  propOr({}, 'lobby'),
);

export const excludedGamesSelector = createSelector(
  configSelector,
  propOr([], 'excludedGames'),
);

export const excludedTablesSelector = createSelector(
  configSelector,
  propOr([], 'excludedTables'),
);

export const tablesWithoutFlagSelector = createSelector(
  lobbyConfigSelector,
  propOr([], 'hide_table_flag'),
);

export const generalConfigSelector = createSelector(
  configSelector,
  (config) => config?.general,
);

export const languagesSelector = createSelector(
  generalConfigSelector,
  (general) => general?.available_languages,
);

export const definitionsSelector = createSelector(
  configSelector,
  (config) => config?.definitions,
);

export const areOutgoingCallsEnabledSelector = createSelector(
  configSelector,
  propOr(true, 'outgoingCalls')
);

export const dealerImageBaseSelector = createSelector(
  definitionsSelector,
  propOr('', 'DEALER_IMAGES'),
);

const defaultLanguage = { code: 'en', label: 'English' };

export const languageSelector = createSelector(
  configSelector,
  (config) => config?.language || defaultLanguage,
);

export const languageCodeSelector = createSelector(
  languageSelector,
  ({ code }) => code
);

export const widgetsSelector = createSelector(
  configSelector,
  (config) => config?.widgets,
);

export const cashierConfigSelector = createSelector(
  configSelector,
  (config) => config?.cashier,
);

export const homeConfigSelector = createSelector(
  configSelector,
  (config) => config?.home,
);

export const filtersSelector = createSelector(
  configSelector,
  propOr({}, 'filters'),
);

export const gameGroupsSelector = createSelector(
  filtersSelector,
  propOr({}, 'game_groups'),
);

export const isCustomLobbySelector = createSelector(
  filtersSelector,
  propOr('unknown', 'game_groups_is_custom_configuration'),
);

export const formatSelector = createSelector(
  configSelector,
  propOr({}, 'amount_display'),
);

export const sortTypeSelector = createSelector(
  filtersSelector,
  (filters) => filters?.tables_sorting_type,
);

export const sortBJGroupConfigSelector = createSelector(
  filtersSelector,
  (filters) => {
    let conf;

    try {
      const config = filters[SORT_FULL_SEATED_BJ_TABLES.CONFIG_ATTR];

      conf = JSON.parse(config);
    } catch (_e) {
      return {};
    }

    return conf;
  },
);

export const gameTypesSelector = createSelector(
  configSelector,
  propOr({}, 'gameTypes'),
);
